// extracted by mini-css-extract-plugin
export default {"container":"spo_2u7vo"};